<template>
    <div>
        <div class="content">
            <p>
                Many of our tools require <a href="https://www.deltaconnected.com/arcdps/">arcdps</a>, a Guild Wars 2 dps meter.
                All tools here are open-source and run on Windows and Linux.
            </p>
        </div>
        <div class="columns">
            <div class="column">
                <ProgramCard name="arcdps Log Manager"
                             status="A manager for all your recorded logs"
                             :image-url="logManagerImage"
                             :detail-route="{name: 'tools-manager'}"
                />
              <br>
              <ProgramCard name="EVTC Inspector"
                           status="here be dragons"
                           :image-url="evtcInspectorImage"
                           :detail-route="{name: 'tools-inspector'}"
              />
            </div>
            <div class="column">
                <ProgramCard name="arcdps Clears"
                             status="Check your raid clears in-game"
                             :image-url="clearsImage"
                             :detail-route="{name: 'tools-arcdps-clears'}"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import ProgramCard from "@/components/ProgramCard";
    import logManagerImage from "@/assets/images/log-manager.png";
    import evtcInspectorImage from "@/assets/images/evtc-inspector.png";
    import clearsImage from "@/assets/images/clears.png";

    export default {
        name: 'tools-summary',
        components: {ProgramCard},
        data() {
            return {
                logManagerImage,
                evtcInspectorImage,
                clearsImage
            }
        }

    }
</script>

<style>
</style>
